// Project Imports
import axios from "utils/axios";
import * as APITypes from "constants/API"
import AuthStore from "modules/login/store/AuthStore";
import checkIsValueEmpty from "utils/checkIsValueEmpty";
import NeedTypeEnum from 'constants/NeedTypeEnum'
import incomeTypeEnum from "constants/incomeTypeEnum";
import ChooseNeedsStore from "modules/choose-needs/store/ChooseNeedsStore";
import { toJS } from "mobx";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import getCookie from "utils/journeyIdCookie/getJourneyId";
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "constants/Constants";
import StorageKeys from "constants/StorageKeys";

class Utils {

  toggleDisabledState = (formRef, fieldName, value) => {

    formRef.$(fieldName).set("disabled", value)

    const fieldValues = formRef.$(fieldName).get()

    if (value) {
      // formRef.$(fieldName).$('target_amount_dropdown').set("value", {})
      switch (fieldName) {
        case NeedTypeEnum.PROTECTION_FOR_MY_FAMILY:
          /* resetting the monthly income */
          formRef.$(fieldName).$('monthly_income').set("value", '')
          /* resetting to the initial default*/
          // formRef.$(fieldName).$('target_amount_type').set("value", formRef.$("protection_for_my_family.target_amount_type").extra.optionList[0])
          break;

        case NeedTypeEnum.SAVE_FOR_RETIREMENT:
          /* resetting to the initial default*/
          // formRef.$(fieldName).$('target_amount_type').set("value", formRef.$("save_for_retirement.target_amount_type").extra.optionList[0])
          break;
        default:
          break;
      }

      for (const key in fieldValues) {
        formRef.$(fieldName).$(key).resetValidation()
      }
    }

    // let previouslySelectedValues = toJS(ChooseNeedsStore.previouslySelectedNeedObject)

    // const needList = Object.keys(previouslySelectedValues)

    // if(!value && needList.length !== 0){

    //     for (let needName in previouslySelectedValues){
    //         if(needName === fieldName){
    //             formRef.$(fieldName).$('target_amount_type').set("value", previouslySelectedValues[needName].target_amount_type)
    //             formRef.$(fieldName).$('target_amount_dropdown').set("value", previouslySelectedValues[needName].selectedtargetAmount)
    //         }
    //     }
    // }
  }

  updateTargetAmountValue = (formController, need_name, value) => {
    let targetAmountType = formController.$(need_name).$("target_amount_type").value.type
    let searchType = ''
    if (targetAmountType == 'recommend_income' || targetAmountType == 'income') {
      searchType = 'income'
    } else {
      searchType = 'lumpsum'
    }

    let selectedOption = formController.$(need_name).$("target_amount_type").extra.optionList.find((item) => item.type === searchType)

    if (need_name === NeedTypeEnum.PROTECTION_FOR_MY_FAMILY) {
      let modeType = formController.$(need_name).$("target_amount_type").extra.optionList.find((item) => item.mode === "LUMPSUM")
      formController.$(need_name).$("target_amount_type").value = modeType
    }

    if (need_name === NeedTypeEnum.SAVE_FOR_RETIREMENT) {
      let modeType = formController.$(need_name).$("target_amount_type").extra.optionList.find((item) => item.mode === "INCOME")
      formController.$(need_name).$("target_amount_type").value = modeType
    }

    if (selectedOption !== undefined) {
      formController.$(need_name).$("target_amount_type").value = selectedOption
    }

    formController.$(need_name).$("target_amount_dropdown").set("type", "hidden")
    formController.$(need_name).$("target_amount_value").set("type", "text")
    formController.$(need_name).$("target_amount_value").value = value
    formController.$(need_name).$("calculator_used").value = true
  }

  createNeedList = (values, need_name, is_selected) => {
    let currentNeedValue = values[need_name]

    let payoutMode = null
    let calculatorUsed = false

    let targetAmountType = currentNeedValue.target_amount_type.mode
    if (targetAmountType !== undefined) {
      payoutMode = currentNeedValue.target_amount_type.mode
    }

    if (currentNeedValue.calculator_used !== undefined) {
      calculatorUsed = currentNeedValue.calculator_used
    }

    if (need_name === NeedTypeEnum.PROTECTION_FOR_MY_HEALTH) {
      payoutMode = incomeTypeEnum.LUMPSUM
    }

    return {
      need_id: currentNeedValue.id,
      target_amount: currentNeedValue.target_amount_dropdown?.id ? currentNeedValue.target_amount_dropdown.id : null,
      is_selected: is_selected,
      is_calculator_used: calculatorUsed,
      payout_mode: payoutMode,
      target_amount_value: currentNeedValue.target_amount_value ? currentNeedValue.target_amount_value : "",
      selected_product_package_id: currentNeedValue?.products_list?.package_id ? currentNeedValue?.products_list?.package_id : null,
      selected_product_risk_type: currentNeedValue?.products_list?.risk ? currentNeedValue?.products_list?.risk : null
    }
  }

  submitDataToTheServer = async (formController) => {
    let values = formController.values();
    let monthlyIncome = values.protection_for_my_family?.monthly_income ? values.protection_for_my_family?.monthly_income : ""
    let education = values.protection_for_my_family?.education ? values.protection_for_my_family?.education : ""
    let location = toJS(values.protection_for_my_family?.location) ? toJS(values.protection_for_my_family?.location) : ""
    let occupation = values.protection_for_my_family?.occupation ? values.protection_for_my_family?.occupation : ""

    let needList = []

    needList.push(
      this.createNeedList(
        values,
        'protection_for_my_family',
        !formController.$("protection_for_my_family").disabled
      )
    )

    needList.push(
      this.createNeedList(
        values,
        'protection_for_my_health',
        !formController.$("protection_for_my_health").disabled
      )
    )

    needList.push(
      this.createNeedList(
        values,
        'grow_my_money',
        !formController.$("grow_my_money").disabled
      )
    )

    needList.push(
      this.createNeedList(
        values,
        'save_for_children',
        !formController.$("save_for_children").disabled
      )
    )

    needList.push(
      this.createNeedList(
        values,
        'save_for_retirement',
        !formController.$("save_for_retirement").disabled
      )
    )

    let data = {
      "journey_id": getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
      "need_list": needList,
      'monthly_income': null,
      'occupation': null,
      'education': null,
      'office_name': null,
      'pin_code': null
    }

    if (!checkIsValueEmpty(monthlyIncome)) {
      data['monthly_income'] = monthlyIncome
      data['occupation'] = occupation.id
      data['education'] = education.id
      data['office_name'] = location[0]?.label
      data['pin_code'] = location[0]?.id
    }

    // ! need_id: 4 : for protection for my family,
    // ! need_id: 3 for retirement calculator
    const FamilyAndRetirementNeedIdArray = [4, 3]
    const needContainingCalculator = data.need_list.filter(item => FamilyAndRetirementNeedIdArray.includes(item.need_id))

    needContainingCalculator.forEach((item) => {

      const { need_id, is_calculator_used } = item

      if (need_id === 4) {
        ChooseNeedsStore.setIsProtectionCalculatorUsed(is_calculator_used)
      } else if (need_id === 3) {
        ChooseNeedsStore.setIsRetirementCalculatorUsed(is_calculator_used)
      }
    })

    const needResponse = await axios.post(APITypes.SAVE_NEED, data)

    await AuthStore.fetchJourneyData()

    if (needResponse.data && needResponse.status == 'success') {
      console.log("Data is ", needResponse.data)
    }

    console.log("Data is ", data)
  }

  updateCalculatorValues = async (monthlyIncomeValue, formController) => {

    const isProtectionCalculatorUsed = formController.$("protection_for_my_family").$("calculator_used").value
    let protectionCalculatorReqObj = toJS(OptimizationStore.protectionCalculatorReqestObject)

    if (isProtectionCalculatorUsed) {

      let { data: { lumpsum }, status } = await axios.post(APITypes.PROTECTION_CALCULATOR, { ...protectionCalculatorReqObj, monthly_income: monthlyIncomeValue });

      this.updateTargetAmountValue(formController, "protection_for_my_family", lumpsum)
      formController.$("protection_for_my_family").$("is_value_updated").set('value', true)

      if (status == 'error') {
        return
      } else {
        AuthStore.fetchJourneyData()
      }
    }
  }

  async fetchPincode(pinCode, form) {
    if (pinCode.charAt(0) == 0 && pinCode.length >= 5) {
      form.$("protection_for_my_family.location").resetValidation()
      form.$("protection_for_my_family.location").invalidate("First number should be non zero")
      form.$("protection_for_my_family.location").set("extra", {
        optionList: [],
      })
      return
    } else if (pinCode.charAt(0) !== 0) {
      form.$("protection_for_my_family.location").resetValidation()
    }

    let regex = /^[1-9][0-9]{5}$/;
    if (regex.test(pinCode)) {

      form.$("protection_for_my_family.location").resetValidation();

      var options = [];
      try {
        let parsedValue = parseInt(pinCode);

        if (parsedValue === NaN) return;
        const response = await axios.get(`${APITypes.GET_PINCODE}?pinCode=${pinCode}`);

        if (response.data[0].city === undefined) {
          return options;
        }
        options.push({
          id: response.data[0].pinCode,
          label: response.data[0].city,
          location: response.data[0].state,
        });
        global.mainLoading(false)
      } catch (error) {
        console.log("Error is ", error);
        form.$("protection_for_my_family.location").invalidate("No matches found");
      } finally {
        form.$("protection_for_my_family.location").set("extra", {
          optionList: options,
        });
        form.$("protection_for_my_family.location").set("value", options);
        global.mainLoading(false)
        return options;
      }
    } else {
      form.$("protection_for_my_family.location").set("extra", {
        optionList: [],
      });
      form.$("protection_for_my_family.location").invalidate("Enter valid PIN Code");
      global.mainLoading(false)
    }
  }

  setTargetAccmountValue = (Form, targetAmountDropdownValue, value) => {
    let targetAmountDropdownType = Form.$("target_amount_dropdown").type
    if (targetAmountDropdownType === "text") {
      if (targetAmountDropdownValue.amount_label.includes("to")) {

        let targetAmountLabel = targetAmountDropdownValue.amount_label.includes("Above") ? targetAmountDropdownValue.amount_label.split("Above") : targetAmountDropdownValue.amount_label.split("to")
        let minAmount = targetAmountDropdownValue.amount_label.includes("Above") ? this.convertToNumber(targetAmountLabel[1].trim()) : this.convertToNumber(targetAmountLabel[0].trim())
        let maxAmount = targetAmountDropdownValue.amount_label.includes("Above") ? this.convertToNumber(targetAmountLabel[1].trim()) + this.convertToNumber(targetAmountLabel[1].trim()) / 2 : this.convertToNumber(targetAmountLabel[1].trim())
        let mid_value = targetAmountLabel[1].trim().split(" ")

        if (Number(value) >= minAmount && Number(value) <= maxAmount) {
          Form.$("target_amount_value").validate()
          return Form.$("target_amount_value").value = value
        } else {
          Form.$("target_amount_value").invalidate(`Enter the value between ${targetAmountDropdownValue.amount_label.includes("Above") ? ` ${targetAmountLabel[1].trim()} to  ${Number(mid_value[0]) + Number(mid_value[0]) / 2} ${mid_value[1]}` : targetAmountDropdownValue.amount_label}`)
          return Form.$("target_amount_value").value = value

        }
      } else if (targetAmountDropdownValue.amount_label.includes("Above")) {
        let targetAmountLabel = targetAmountDropdownValue.amount_label.split("Above")
        let minAmount = this.convertToNumber(targetAmountLabel[1].trim())
        if (Number(value) >= minAmount) {
          Form.$("target_amount_value").validate()
          return Form.$("target_amount_value").value = value
        } else {
          Form.$("target_amount_value").invalidate(`Enter the value ${targetAmountDropdownValue?.amount_label?.replace("Above", "above")}`)
          return Form.$("target_amount_value").value = value
        }
      } else {
        let targetAmountLabel = targetAmountDropdownValue.amount_label
        let Amount = this.convertToNumber(targetAmountLabel.trim())
        if (Number(value) === Amount) {
          Form.$("target_amount_value").validate()
          return Form.$("target_amount_value").value = value
        } else {
          Form.$("target_amount_value").invalidate(`Enter the value ${targetAmountDropdownValue.amount_label}`)
          return Form.$("target_amount_value").value = value

        }
      }

    } else {
      return Form.$("target_amount_value").value = value
    }


  }

  convertToNumber = (input) => {

    const inputLower = input.toLowerCase();
    let number = 0;

    if (inputLower.includes("lac") || inputLower.includes("lacs")) {
      const parts = inputLower.split(/[^\d]+/);
      for (const part of parts) {
        if (part) {
          number += parseFloat(part);
        }
      }
      number *= 100000;
    } else if (inputLower.includes("crore") || inputLower.includes("cr")) {
      const parts = inputLower.split(/[^\d]+/);
      for (const part of parts) {
        if (part) {
          number += parseFloat(part);
        }
      }
      number *= 10000000;
    } else if (inputLower.includes("thousand")) {
      const parts = inputLower.split(/[^\d]+/);
      for (const part of parts) {
        if (part) {
          number += parseFloat(part);
        }
      }
      number *= 1000;
    }


    return number;
  }

  getProductList = async (needId, payoutType) => {
    let requestObj = {
      need_type: needId,
      payout_type: payoutType
    }
    let response = await axios.post(APITypes.GET_PRODUCTS_LIST, requestObj);
    return response?.data
  }

  prefillProductsList = async () => {
    let agentID = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE)
    let isPosp =  localStorage.getItem(StorageKeys.IS_POSP)
    const response = await axios.get(`${APITypes.GET_PRODUCTS_LIST}?agent_id=${agentID}&is_posp=${isPosp}`)
    return response.data;
  }

  filterProductlist = (ulip_training, productdata) => {
    let filterdata = []
    if (!ulip_training) {
      filterdata = productdata.filter((item) => item.risk != "high");
    } else {
      filterdata = productdata
    }
    return filterdata
  }


}


export default new Utils();